/* eslint-disable indent */
import Component from 'classes/Component'

export default class MiniCart extends Component {
  constructor() {
    super({
      element: '.mini_cart',
      elements: {
        body: document.body
      }
    })

    if (document.getElementsByClassName('page-wines').length > 0 || document.getElementsByClassName('page-product').length > 0) {

      this.closeMiniCartButton = document.querySelector('.close_mini_cart');
      this.miniCartToggle = document.querySelector('.miniCartToggle');

      this.changeQtyActionName = 'productQtyChange'
      this.ajaxUrl = '/wp-admin/admin-ajax.php'
      this.createInteractions()
      this.setNrItemsInCartHeader()

    }

  }

  setNrItemsInCartHeader() {
    if (parseInt(numberInCart) > 0) {
      document.getElementById('miniCartNrItems').innerHTML = numberInCart
    }
  }

  toggleMiniCart = () => {
    const el = document.querySelector('#mini_cart');
    el.classList.toggle("visible");
  }

  closeMiniCart = () => {
    const el = document.querySelector('#mini_cart');
    el.classList.remove("visible");
  }

  rmvQty = (element) => {

    const target = element.target
    const parent = target.parentElement
    const currentQty = Number(parent.querySelector('span.current_qty').innerHTML) || 1

    parent.style.pointerEvents = 'none' /** disable action while waiting for response */

    jQuery.when(this.ajaxRequest(parent.getAttribute('item_key'), currentQty - 1)).then((res) => {
      let response = JSON.parse(res)
      if (response.result) { /** if true success */
        if (currentQty - 1 <= 0) {
          /**
          * runs if product is removed from cart ( qty <= 0 )
          */

          this.updateCart(response, parent.getAttribute('item_key'))
          document.querySelector(`div[item_key_container="${parent.getAttribute('item_key')}"]`).remove()
          const productList = document.getElementById('product_list').querySelectorAll('.mini_cart_each_product')
          if (productList.length <= 0) {
            // empty cart
            document.getElementById('product_list').remove()
            document.getElementById('mini_cart_totals').remove()
            document.getElementById('mini_cart_your_order').remove()
            document.getElementById('mini_cart_empty').style.display = 'block'
            document.getElementById('checkoutMiniCart').style.display = 'none'
          }
        } else {
          /**
           * runs when product is still in cart ( qty > 0)
           */
          this.updateCart(response, parent.getAttribute('item_key'))
          parent.querySelector('.current_qty').innerHTML = currentQty - 1
        }
      }
      parent.style.pointerEvents = 'unset' /** enable action */
    }).catch((err) => {
      console.log(err)
    })
  }

  addQty = (element) => {
    const target = element.target
    const parent = target.parentElement
    const currentQty = Number(parent.querySelector('span.current_qty').innerHTML) || 1
    parent.style.pointerEvents = 'none' /** disable action while waiting for response */
    jQuery.when(this.ajaxRequest(parent.getAttribute('item_key'), currentQty + 1)).then((res) => {
      let response = JSON.parse(res)
      if (response.result) { /** if true success */
        this.updateCart(response, parent.getAttribute('item_key'))
        parent.querySelector('.current_qty').innerHTML = currentQty + 1

      }
      parent.style.pointerEvents = 'unset' /** enable action */
    }).catch((err) => {
      console.log(err)
    })
  }

  removeProd = (element) => {
    const target = element.target
    target.style.pointerEvents = 'none'

    jQuery.when(this.ajaxRequest(target.getAttribute('item_key'), 0)).then((res) => {
      let response = JSON.parse(res)
      if (response.result) {
        this.updateCart(response)

        document.querySelector(`div[item_key_container="${target.getAttribute('item_key')}"]`).remove()
        const productList = document.getElementById('product_list').querySelectorAll('.mini_cart_each_product')

        if (productList.length <= 0) {
          // empty cart
          document.getElementById('product_list').remove()
          document.getElementById('mini_cart_totals').remove()
          document.getElementById('mini_cart_your_order').remove()
          document.getElementById('mini_cart_empty').style.display = 'block'
          document.getElementById('checkoutMiniCart').style.display = 'none'
        }
      }
      target.style.pointerEvents = 'unset'
    }).catch((err) => {
      console.log(err)
    })

  }

  updateCart(updatedInfo, id = 0) {

    if (id != 0) {
      const mainParent = document.querySelector(`div[item_key_container="${id}"]`)
      /** update price */
      mainParent.querySelector('.priceContent').innerHTML = updatedInfo.product_total + '€'
    }
    /** update product amount */
    const cartOrder = document.getElementById('mini_cart_your_order').innerHTML

    let currentCart = cartOrder.replace(/\d+/g, updatedInfo.total_items_in_cart);
    let totalNumberInCart = currentCart.match(/\d+/)[0];


    document.getElementById('miniCartNrItems').innerHTML = totalNumberInCart

    document.getElementById('mini_cart_your_order').innerHTML = cartOrder.replace(/\d+/g, updatedInfo.total_items_in_cart)
    /** update subtotal */
    //document.getElementsByClassName('subtotal_iva')[0].querySelector('span > span').innerHTML = updatedInfo.sub_total + '€'
    /** update shipping fees */
    //document.getElementsByClassName('shipping_fee')[0].querySelector('span > span').innerHTML = updatedInfo.shipping_fees + '€'
    /** update total */
    const totalCart = document.getElementById('cartTotalValue');

    totalCart.innerHTML = updatedInfo.sub_total + '€'
  }
  /**
   * sends ajax request to change cart prod qty
   */
  async ajaxRequest(id, qty) {
    let data = new FormData()
    data.append('action', this.changeQtyActionName)
    data.append('id', id)
    data.append('qty', qty)

    return jQuery.ajax({
      type: 'POST',
      url: this.ajaxUrl,
      data: data,
      contentType: false,
      processData: false
    })
  }
  /*   closeMiniCart = () => {

      const el = document.querySelector('#mini_cart');
      el.classList.remove("visible");
    } */

  createInteractions = () => {
    let rmvQty = document.getElementsByClassName('remove_qty')
    for (let i = 0; i < rmvQty.length; i++) {
      rmvQty[i].addEventListener('click', this.rmvQty)
    }
    let addQty = document.getElementsByClassName('add_qty')
    for (let i = 0; i < addQty.length; i++) {
      addQty[i].addEventListener('click', this.addQty)
    }
    let removeProd = document.getElementsByClassName('remove_product')
    for (let i = 0; i < removeProd.length; i++) {
      removeProd[i].addEventListener('click', this.removeProd)
    }

    this.closeMiniCartButton.addEventListener('click', this.closeMiniCart);
    this.miniCartToggle.addEventListener('click', this.toggleMiniCart);

  }

}
